//#region src/kiosk_availability_state.ts
let KioskAvailabilityState = /* @__PURE__ */ function(KioskAvailabilityState) {
	KioskAvailabilityState[KioskAvailabilityState["Available"] = 0] = "Available";
	KioskAvailabilityState[KioskAvailabilityState["TurnedOff"] = 1] = "TurnedOff";
	KioskAvailabilityState[KioskAvailabilityState["MaintenanceMode"] = 2] = "MaintenanceMode";
	KioskAvailabilityState[KioskAvailabilityState["Loading"] = 3] = "Loading";
	return KioskAvailabilityState;
}({});
//#endregion
export { KioskAvailabilityState };

//# sourceMappingURL=kiosk_availability_state.js.map